/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 指定构成字符串的字符类型。
 */
export const GetRandomStringType = {
  Numeric: "numeric",
  Lower: "lower",
  Upper: "upper",
  Alpha: "alpha",
  Alphanumeric: "alphanumeric",
  Hex: "hex",
} as const;
/**
 * 指定构成字符串的字符类型。
 */
export type GetRandomStringType = ClosedEnum<typeof GetRandomStringType>;

export const GetRandomStringType$zodSchema = z.enum([
  "numeric",
  "lower",
  "upper",
  "alpha",
  "alphanumeric",
  "hex",
]).describe("指定构成字符串的字符类型。");

export type GetRandomStringRequest = {
  length?: number | undefined;
  type?: GetRandomStringType | undefined;
};

export const GetRandomStringRequest$zodSchema: z.ZodType<
  GetRandomStringRequest
> = z.object({
  length: z.int().default(16).describe(
    "你希望生成的字符串的长度。有效范围是 1 到 1024。",
  ),
  type: GetRandomStringType$zodSchema.default("alphanumeric"),
});

export type GetRandomStringInternalServerErrorDetails = {};

export const GetRandomStringInternalServerErrorDetails$zodSchema: z.ZodType<
  GetRandomStringInternalServerErrorDetails
> = z.object({});

/**
 * 服务器内部错误。
 */
export type GetRandomStringInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetRandomStringInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetRandomStringInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetRandomStringInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetRandomStringInternalServerErrorDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("服务器内部错误。");

export type GetRandomStringBadRequestDetails = {};

export const GetRandomStringBadRequestDetails$zodSchema: z.ZodType<
  GetRandomStringBadRequestDetails
> = z.object({});

/**
 * 无效的请求参数。
 */
export type GetRandomStringBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetRandomStringBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetRandomStringBadRequestResponseBody$zodSchema: z.ZodType<
  GetRandomStringBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetRandomStringBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("无效的请求参数。");

/**
 * 生成成功！
 */
export type GetRandomStringResponseBody = { text?: string | undefined };

export const GetRandomStringResponseBody$zodSchema: z.ZodType<
  GetRandomStringResponseBody
> = z.object({
  text: z.string().optional(),
}).describe("生成成功！");

export type GetRandomStringResponse =
  | GetRandomStringResponseBody
  | GetRandomStringBadRequestResponseBody
  | GetRandomStringInternalServerErrorResponseBody;

export const GetRandomStringResponse$zodSchema: z.ZodType<
  GetRandomStringResponse
> = z.union([
  z.lazy(() => GetRandomStringResponseBody$zodSchema),
  z.lazy(() => GetRandomStringBadRequestResponseBody$zodSchema),
  z.lazy(() => GetRandomStringInternalServerErrorResponseBody$zodSchema),
]);
